import request from "../utils/request";

export function getOmbudsmanNotifications(company) {
  let query = "";
  if (company !== undefined) {
    query += `?company=${company}`;
  }
  return request({
    url: `/ombudsman/notifications${query}`,
    method: "get",
  });
}

export function getOmbudsmanList(query) {
  const params = {
    page: query && query.page != null ? query.page : 1,
    "sort-by": query && query.sortBy != null ? query.sortBy : undefined,
    "sort-desc": query && query.sortDesc != null ? query.sortDesc : undefined,
    size: query && query.size != null ? query.size : 15,
  };

  // Add filter as JSON string if filters exist
  if (query && query.filter) {
    const filterObj = {};

    // Add text filter if it exists
    if (query.filter.text) {
      filterObj.text = query.filter.text;
    }

    // Add status filter if it exists (including 0 which is a valid status)
    if (
      query.filter.status !== undefined &&
      query.filter.status !== null &&
      query.filter.status !== ""
    ) {
      filterObj.status = query.filter.status;
    }

    // Only add filter param if we have actual filters
    if (Object.keys(filterObj).length > 0) {
      params.filter = JSON.stringify(filterObj);
    }
  }

  return request({
    url: `/ombudsman`,
    method: "get",
    params,
  });
}

export function getOmbudsman(id) {
  return request({
    url: `/ombudsman/${id}`,
    method: "get",
  });
}

export function createOmbudsmanEvent(id, data) {
  return request({
    url: `/ombudsman/${id}/events`,
    method: "post",
    data,
  });
}

export function resendOmbudsmanTask(id, eventId) {
  return request({
    url: `/ombudsman/${id}/events/${eventId}/resend`,
    method: "post",
  });
}

export function getOmbudsmanEvents(id) {
  return request({
    url: `/ombudsman/${id}/events`,
    method: "get",
  });
}

export function createOmbudsmanMonitoring(id, data) {
  return request({
    url: `/ombudsman/${id}/monitoring`,
    method: "post",
    data,
  });
}

export function getOmbudsmanMonitoring(id) {
  return request({
    url: `/ombudsman/${id}/monitoring`,
    method: "get",
  });
}

export function setOmbudsmanMonitoringVisibility(monitoring, hidden) {
  return request({
    url: `/ombudsman/${monitoring.ombudsman}/monitoring/${monitoring._id}`,
    method: "post",
    data: {
      hidden,
    },
  });
}

export function setOmbudsmanMonitoringResponseEnabled(complaint, enabled) {
  return request({
    url: `/ombudsman/${complaint._id}/monitoring-response`,
    method: "post",
    data: {
      enabled,
    },
  });
}

export function classifyOmbudsman(id, data) {
  return request({
    url: `/ombudsman/${id}/classification`,
    method: "patch",
    data,
  });
}

export function associatePhoneServiceProtocol(id, protocol, date) {
  return request({
    url: `/ombudsman/${id}/associatePhoneServiceProtocol`,
    method: "post",
    data: {
      protocol,
      date,
    },
  });
}
